<template>
  <div class="quote-information">
    <b-dropdown
      :id="'quote-info-dropdown' + quoteInfoTableId"
      text="Quote information"
      :ref="'quote-info-dropdown' + quoteInfoTableId"
      @hidden="catchHtmlTable"
    >
      <Searcher
        :id="'quote-information-table' + quoteInfoTableId"
        :fields="quoteInfoFields"
        :data="quoteInfoTableContent"
        addRows
        deleteRows
        :tableStyles="tableStyles"
        ref="quote-information"
      >
        <template #table-header>
          <tr name="table-fields">
            <th
              :style="tableStyles.header"
              :colspan="currentCannedResponse.fields.length + 2"
            >
              Quote ID: {{ haulInfo[quoteInfoTableId].id }}
            </th>
          </tr>
          <tr name="table-fields">
            <th
              :style="tableStyles.th"
              :colspan="currentCannedResponse.fields.length + 2"
            >
              Quote Information - Trip
            </th>
          </tr>
        </template>
        <template
          v-for="(slot, index) in currentCannedResponse.fields"
          v-slot:[slot]="slotProps"
        >
          <input
            v-if="
              slot.toLowerCase().includes('rate') ||
                slot.toLowerCase().includes('tarifa')
            "
            v-model="slotProps.row[slot]"
            :key="`rate_${index}`"
            class="table-canned__tableField"
            cell-type="editable-cell"
            type="number"
            @change="updateRateValue(slotProps.row[slot])"
          />
          <input
            v-else-if="
              slot.toLowerCase() === 'linear_feet' ||
                slot.toLowerCase() === 'pies_lineales'
            "
            v-model="slotProps.row[slot]"
            :key="`linear_feet_${index}`"
            class="table-canned__tableField"
            cell-type="editable-cell"
            type="number"
          />
          <input
            v-else
            v-model="slotProps.row[slot]"
            :key="index"
            class="table-canned__tableField"
            cell-type="editable-cell"
            type="text"
          />
        </template>
        <template #mode="slotProps">
          <input
            v-model="slotProps.row.mode"
            class="table-canned__tableField"
            list="mode-list"
            cell-type="editable-cell"
          />
          <datalist id="mode-list">
            <option v-for="(modeOption, index) in modes" :key="index">
              {{ modeOption }}
            </option>
          </datalist>
        </template>
        <template #modo="slotProps">
          <input
            v-model="slotProps.row.modo"
            class="table-canned__tableField"
            list="mode-list"
            cell-type="editable-cell"
          />
          <datalist id="mode-list">
            <option v-for="(modeOption, index) in modes" :key="index">
              {{ modeOption }}
            </option>
          </datalist>
        </template>
        <template #equipment="slotProps">
          <input
            v-model="slotProps.row.equipment"
            class="table-canned__tableField"
            list="equipment-list"
            cell-type="editable-cell"
          />
          <datalist id="equipment-list">
            <option v-for="(equipmentOption, index) in equipment" :key="index">
              {{ equipmentOption }}
            </option>
          </datalist>
        </template>
        <template #equipo="slotProps">
          <input
            v-model="slotProps.row.equipo"
            class="table-canned__tableField"
            list="equipment-list"
            cell-type="editable-cell"
          />
          <datalist id="equipment-list">
            <option v-for="(equipmentOption, index) in equipment" :key="index">
              {{ equipmentOption }}
            </option>
          </datalist>
        </template>
        <template #linear_feet="slotProps">
          <input
            v-model="slotProps.row.linear_feet"
            :key="`linear_feet`"
            class="table-canned__tableField"
            cell-type="editable-cell"
            type="number"
          />
        </template>
        <template #pies_lineales="slotProps">
          <input
            v-model="slotProps.row.pies_lineales"
            :key="`pies_lineales`"
            class="table-canned__tableField"
            cell-type="editable-cell"
            type="number"
          />
        </template>
      </Searcher>
      <div class="custom-modal-footer">
        <b-button class="custom-modal-footer__ok-button" @click="hideModal">
          OK
        </b-button>
      </div>
    </b-dropdown>
  </div>
</template>

<script>
import Searcher from "roachcat-components-library/table";
import modesByDepartment from "../../../../../../utils/OTR/modesByDepartment";

import { mapGetters } from "vuex";
export default {
  name: "QuoteInformation",
  components: {
    Searcher
  },
  props: [
    "quoteInfoTableId",
    "cannedResponseName",
    "ftlQuoteTablesGuid",
    "quoteMode",
    "currentCannedResponse",
    "pcmiler"
  ],
  data() {
    return {
      quoteInfoTableContent: null,
      quoteInfoFields: [],
      tableStyles: {
        table: {
          //Modifica los estilos de la etiqueta “table”
          "border-collapse": "collapse",
          width: "700px",
          "text-align": "center"
        },
        header: {
          //Modifica los estilos de las celdas del header que contiene los campos pasados en la propiedad “fields”.
          "background-color": "rgb(230, 230, 250)",
          border: "1px solid rgb(230, 230, 250)",
          "font-size": "13px",
          padding: "4px 8px"
        },
        th: {
          //Modificar los estilos de cada una de las celdas de la información
          "background-color": "rgb(239, 239, 239)",
          "line-height": "10px",
          border: "1px solid rgb(230, 230, 250)",
          "font-size": "12px"
        }
      },
      equipment: [
        "Dry Van",
        "Flatbed/Step deck",
        "RGN",
        "Car Carrier",
        "Intermodal",
        "Reefer",
        "Conestoga",
        "Power Only",
        "Drive Away",
        "Reefer Van",
        "Reefer Less than Truckload"
      ],
      actualQueue: null,
      modes: null,
      selectedTrailer: null,
      haulInfo: null,
      htmlTable: null,
      rateNumber: null
    };
  },
  computed: {
    ...mapGetters("quotes/quote", ["showModeList"]),
    ...mapGetters("quotes/quote", ["showSalePrice"]),
    ...mapGetters("quotes/quote", ["showEquipmentType"])
  },
  watch: {
    async showModeList(value) {
      this.modes = value;
    }
  },
  async created() {
    if (this.currentCannedResponse) {
      this.quoteInfoTableContent = [];
      this.quoteInfoTableContent = this.currentCannedResponse?.table_content;
      this.actualQueue = localStorage.getItem("actual-queue");
      const HHPricingModel =
        this.actualQueue === "hh" &&
        this.quoteInfoTableContent.length === 1 &&
        this.quoteMode === "Partial F/SD (LTL Spot Market)";
      const FTLPricingModel =
        this.actualQueue === "ftl" &&
        this.quoteInfoTableContent.length === 1 &&
        this.quoteMode === "Partial Van (LTL Spot Market)";
      const isPartial = this.cannedResponseName.toLowerCase().match("partial");
      if (isPartial && (HHPricingModel || FTLPricingModel)) {
        this.quoteInfoTableContent.push(this.quoteInfoTableContent[0]);
      }
      const arrayRow = Object.keys(this.quoteInfoTableContent[0]);
      for (let i = 0; i < arrayRow.length; i += 1) {
        this.quoteInfoFields.push({
          label: arrayRow[i].replaceAll("_", " "),
          propName: arrayRow[i]
        });
      }
      this.haulInfo = this.$store.getters["quotes/quote/showQuoteById"].haul;
      this.modes = this.showModeList.map(el => el.name);
      let isPartialMode = this.validateModeType();
      this.getSelectedTrailer();
      this.buildTableDetails();
      if (isPartialMode) {
        this.pushPartialModeRow();
      }
      this.updateRateValue();
    }
  },
  mounted() {
    this.catchHtmlTable();
  },
  methods: {
    validateModeType() {
      if (
        this.haulInfo[this.quoteInfoTableId].tms_mode.name
          .toLowerCase()
          .match("partial")
      ) {
        return true;
      } else {
        return false;
      }
    },
    pushPartialModeRow() {
      let ifLinearFeetField = false;
      let indexLinearFeet;
      this.quoteInfoFields.forEach((element, index) => {
        if (element.propName === "linear_feet") {
          ifLinearFeetField = element.propName === "linear_feet";
          indexLinearFeet = index;
        }
      });
      let linearFeetLanguage;
      if (!ifLinearFeetField) {
        if (this.cannedResponseName.toLowerCase().match("español")) {
          linearFeetLanguage = "pies_lineales";
          this.quoteInfoFields.push({
            label: "pies lineales",
            propName: "pies_lineales"
          });
        } else {
          linearFeetLanguage = "linear_feet";
          this.quoteInfoFields.push({
            label: "linear feet",
            propName: "linear_feet"
          });
        }
      } else {
        this.quoteInfoFields.splice(indexLinearFeet, 1);
      }
      if (this.quoteInfoTableContent.length > 1) {
        for (let i = 0; i < this.quoteInfoTableContent.length; i += 1) {
          this.quoteInfoTableContent[i][linearFeetLanguage] = this.haulInfo[
            this.quoteInfoTableId
          ].linear_feet;
        }
      } else {
        this.quoteInfoTableContent[0][linearFeetLanguage] = this.haulInfo[
          this.quoteInfoTableId
        ].linear_feet;
      }
    },
    catchHtmlTable() {
      let tableInfo = {};
      // this.setRate();
      tableInfo.tableType = "quote-information";
      tableInfo.tableId = `{quote_information_trip_${this.quoteInfoTableId +
        1}}`;
      this.htmlTable = this.$refs["quote-information"].getTableHtml();
      tableInfo.htmlTable = this.htmlTable.outerHTML;
      this.$refs[`quote-info-dropdown${this.quoteInfoTableId}`].hide(true);
      this.$emit("addTableHtml", tableInfo);
    },
    updateRateValue(rateValue) {
      if (!rateValue) {
        if (this.cannedResponseName.toLowerCase().match("español")) {
          rateValue = this.quoteInfoTableContent[0].tarifa_usd;
        } else {
          rateValue = this.quoteInfoTableContent[0].rate_usd;
        }
      } else {
        if (this.cannedResponseName.toLowerCase().match("español")) {
          this.quoteInfoTableContent[0].tarifa_usd = rateValue;
        } else {
          this.quoteInfoTableContent[0].rate_usd = rateValue;
        }
      }
      this.$store.commit("cannedResponsesModule/setRate", {
        tripNumber: this.ftlQuoteTablesGuid,
        rate_usd: rateValue !== "" ? parseInt(rateValue) : null
      });
    },
    hideModal() {
      this.$refs["quote-info-dropdown" + this.quoteInfoTableId].hide(true);
      this.catchHtmlTable();
    },
    // ! Trae la información de los trailers seleccionados.
    getSelectedTrailer() {
      let selectedTrailer = this.$store.getters[
        "carrierCost/showTrailerSelectedInfo"
      ][this.quoteInfoTableId].trailerType;
      if (selectedTrailer !== null) {
        this.selectedTrailer = selectedTrailer.slice(
          0,
          selectedTrailer.indexOf("(")
        );
      }
    },
    buildTableDetails() {
      let quoteInfoCopy = JSON.parse(
        JSON.stringify(this.quoteInfoTableContent)
      );
      for (let i = 0; i < quoteInfoCopy.length; i += 1) {
        if (modesByDepartment.TCModes.includes(this.quoteMode)) {
          if (this.cannedResponseName.toLowerCase().match("español")) {
            quoteInfoCopy[i].modo = this.quoteMode;
            if (this.selectedTrailer) {
              quoteInfoCopy[i].equipo = this.selectedTrailer;
            } else if (this.quoteMode === "FTL – Non-Hazmat") {
              quoteInfoCopy[i].equipo = "Reefer Van";
            } else {
              quoteInfoCopy[i].equipo = this.showEquipmentType;
            }
            quoteInfoCopy[i].tiempo_de_transito = this.calculateTransitTime();
            quoteInfoCopy[i].tarifa_usd = this.enterSalePriceValue(i);
            this.quoteInfoTableContent = quoteInfoCopy;
          } else if (this.cannedResponseName == "REEFER LTL QUOTE") {
            quoteInfoCopy[i].mode = this.quoteMode;
            quoteInfoCopy[i].rate_usd = this.enterSalePriceValue(i);
            this.quoteInfoTableContent = quoteInfoCopy;
          } else {
            quoteInfoCopy[i].mode = this.quoteMode;
            if (this.selectedTrailer) {
              quoteInfoCopy[i].equipment = this.selectedTrailer;
            } else if (this.quoteMode === "FTL – Non-Hazmat") {
              quoteInfoCopy[i].equipment = "Reefer Van";
            } else {
              quoteInfoCopy[i].equipment = this.showEquipmentType;
            }
            quoteInfoCopy[i].transit_time = this.calculateTransitTime();
            quoteInfoCopy[i].rate_usd = this.enterSalePriceValue(i);
            this.quoteInfoTableContent = quoteInfoCopy;
          }
        } else if (this.cannedResponseName.toLowerCase().match("español")) {
          quoteInfoCopy[i].modo = this.quoteMode;
          if (this.selectedTrailer) {
            quoteInfoCopy[i].equipo = this.selectedTrailer;
          } else {
            if (this.quoteMode === "Partial Van (LTL Spot Market)") {
              let modo = [this.quoteMode];
              modo.push("FTL - Dry");
              quoteInfoCopy[i].modo = modo[i];
              quoteInfoCopy[i].equipo = "Dry Van";
            }
            if (this.quoteMode === "FTL - Dry") {
              quoteInfoCopy[i].equipo = "Dry Van";
            }
            if (this.quoteMode === "Partial F/SD (LTL Spot Market)") {
              let modo = [this.quoteMode];
              modo.push("FTL - F/SD");
              quoteInfoCopy[i].modo = modo[i];
              quoteInfoCopy[i].equipo = "Flatbed";
            }
            if (this.quoteMode === "FTL - F/SD") {
              quoteInfoCopy[i].equipo = "Flatbed";
            }
          }
          quoteInfoCopy[i].tiempo_de_transito = this.calculateTransitTime();
          quoteInfoCopy[i].tarifa_usd = this.enterSalePriceValue(i);
          this.quoteInfoTableContent = quoteInfoCopy;
        } else {
          quoteInfoCopy[i].mode = this.quoteMode;
          if (this.selectedTrailer) {
            quoteInfoCopy[i].equipment = this.selectedTrailer;
          } else {
            if (this.quoteMode === "Partial Van (LTL Spot Market)") {
              let mode = [this.quoteMode];
              mode.push("FTL - Dry");
              quoteInfoCopy[i].mode = mode[i];
              quoteInfoCopy[i].equipment = "Dry Van";
            }
            if (this.quoteMode === "FTL - Dry") {
              quoteInfoCopy[i].equipment = "Dry Van";
            }
            if (this.quoteMode === "Partial F/SD (LTL Spot Market)") {
              let modo = [this.quoteMode];
              modo.push("FTL - F/SD");
              quoteInfoCopy[i].mode = modo[i];
              quoteInfoCopy[i].equipment = "Flatbed";
            }
            if (this.quoteMode === "FTL - F/SD") {
              quoteInfoCopy[i].equipment = "Flatbed";
            }
          }
          quoteInfoCopy[i].transit_time = this.calculateTransitTime();
          quoteInfoCopy[i].rate_usd = this.enterSalePriceValue(i);
          this.quoteInfoTableContent = quoteInfoCopy;
        }
      }
      // this.setRate();
    },
    calculateTransitTime() {
      const transitTime = this.pcmiler?.miles / 600;
      return transitTime
        ? Math.ceil(transitTime) +
            " " +
            (this.cannedResponseName.toLowerCase().includes("español")
              ? "Dias"
              : "Days")
        : "__ " +
            (this.cannedResponseName.toLowerCase().includes("español")
              ? "Dias"
              : "Days");
    },
    enterSalePriceValue(index) {
      if (this.showSalePrice) {
        if (this.showSalePrice.length > 1) {
          const isPartial = this.cannedResponseName
            .toLowerCase()
            .match("partial");
          return this.quoteMode.includes(
            "Partial Van (LTL Spot Market)",
            "Partial F/SD (LTL Spot Market)"
          ) && isPartial
            ? this.showSalePrice[index]
            : this.showSalePrice[1];
        } else {
          return this.showSalePrice;
        }
        // return "$" + this.showSalePrice[this.ftlQuoteTablesGuid];
      }
      // return "$";
      return null;
    }
    /* setRate() {
      const validationRate = /^[$]+[0-9]+$/;
      if (this.rateValue?.match(validationRate)) {
        this.getOnlyNumbers();
      } else {
        this.rateValue = "$";
        this.rateNumber = null;
      }
    }, */
    /* getOnlyNumbers() {
      if (this.rateValue?.includes("$")) {
        this.rateNumber = this.rateValue;
        const symbolIndex = this.rateNumber?.indexOf("$");
        this.rateNumber = Number(this.rateNumber?.slice(symbolIndex + 1));
        this.updateRateValue(this.rateNumber);
      }
    } */
  }
};
</script>

<style lang="scss" scoped>
.quote-information {
  @extend %canned-tables;
  display: flex;
}
::v-deep .table-component {
  padding: 0 1rem;
}
::v-deep .button-toolbar {
  margin: 0;
  display: flex;
  justify-content: start;
  &__button {
    @include secondary-button;
  }
}
::v-deep .table td {
  font-size: 13px;
  padding: 0;
  border: 1px solid rgb(230, 230, 250);
}
::v-deep .table__delete-button {
  & button {
    border-radius: 0.25rem;
  }
}
.table-canned {
  &__tableField {
    display: inline-block;
    border: none;
    min-width: 100px;
    width: 100%;
    height: 28px;
    &:focus {
      outline: none;
    }
    &--rate {
      display: flex;
      align-items: center;
    }
  }
}
</style>
